import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import useClickOutside from "../../../../cp/hooks/useClickOutside";
import { getEventNotification, eventNotificationClick } from "../../../../api/player/eventNotification";
import { Event } from "../../../../cp/components/Comet";
import { CButton, CPortal } from "../UI";

import "./style.scss";

export default ({ preview }) => {
    const timeout = useRef(null);

    const [notification, setNotification] = useState(null);

    const getNotification = async (id) => {
        const _notification = await getEventNotification(id);
        setNotification(_notification)
    }

    useEffect(() => {
        if (preview) {
            getNotification(preview)
        }
    }, [])

    useEffect(() => {
        clearTimeout(timeout.current);

        if (notification?.time && !preview) {
            timeout.current = setTimeout(() => {
                setNotification(null);
            }, notification.time * 1000)
        }

        return () => clearTimeout(timeout.current);

    }, [notification]);

    const handleShowNotification = (notification) => !preview && setNotification(notification);
    const handleUpdateNotification = (notification) => setNotification(prev => (preview && notification?.id === prev?.id) ? notification : prev);

    const handleClickNotification = async () => {
        if (preview) return;
        try {
            await eventNotificationClick(notification.id);
        } catch (error) {
            console.error(error);
        }
    };

    const ref = useClickOutside(() => handleShowNotification(null));

    return <>
        <Event event={"event/notification"} handler={handleShowNotification} />
        <Event event={"event/notification:update"} handler={handleUpdateNotification} />

        <CPortal>
            {notification &&
                <motion.div
                    ref={ref}
                    key="event-notification-modal"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="event-notification-modal"
                    style={{ background: notification.banner ? `url(${[notification.banner, new Date().getTime()].join('?')}) center center / cover no-repeat` : 'rgba(var(--app-color-dark-rgb), 80%)' }}
                    tabIndex={-1}
                    onClick={handleClickNotification}
                >
                    <a
                        href={notification.link}
                        target="_blank"
                    >
                        {notification.header && <div className="event-notification-modal-header">{notification.header}</div>}
                        <p>{notification.text}</p>
                    </a>
                    <CButton
                        blank
                        icon="close"
                        className="event-notification-modal-close"
                        onClick={() => handleShowNotification(null)}
                    />
                    {!!notification.time && <motion.div
                        initial={{ width: "0%" }}
                        animate={{ width: "100%" }}
                        transition={{
                            ease: "linear",
                            duration: notification.time
                        }}
                        className="event-notification-modal-progress"
                    />}
                </motion.div>
            }
        </CPortal>

    </>
}